"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _actions = require("@otpusk/apisearch-toolbox/dist/search/actions");
var _constants = require("../../constants");
var _actions2 = require("./store/actions");
var _excluded = ["formik"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getActiveTransport = function getActiveTransport(transportObj) {
  return R.call(R.pipe(R.toPairs, R.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      isActive = _ref2[1];
    return isActive;
  }), R.ifElse(Boolean, R.head, R.always('no'))), transportObj);
};
var resetTransportObj = function resetTransportObj(transportObj) {
  return R.call(R.pipe(R.toPairs, R.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      code = _ref4[0];
    return [code, false];
  }), R.fromPairs), transportObj);
};
var mapWithIndex = R.addIndex(R.map);
var withDepartureControlProps = function withDepartureControlProps(Component) {
  var WithDepartureControlProps = function WithDepartureControlProps(_ref5) {
    var formik = _ref5.formik,
      props = _objectWithoutProperties(_ref5, _excluded);
    var dispatch = (0, _reactRedux.useDispatch)();
    var touched = formik.touched,
      values = formik.values,
      setValues = formik.setValues;
    var countryID = values[_fn.QUERY_PARAMS.COUNTRY],
      departuresIDs = values[_fn.QUERY_PARAMS.DEPARTURES],
      transports = values[_fn.QUERY_PARAMS.TRANSPORTS];
    var departuresSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getDepartures)(), [{
        geoID: countryID || 0
      }]);
    }, [countryID]);
    var valuesList = (0, _react.useMemo)(function () {
      return mapWithIndex(function (departureID, index) {
        return {
          departureID: departureID,
          transport: getActiveTransport(transports[index])
        };
      }, departuresIDs);
    }, [departuresIDs, transports]);
    var isMaxSizeOfValues = R.equals(valuesList.length, _constants.MAIN_QUERIES.length);
    var departures = (0, _reactRedux.useSelector)(departuresSelector);
    var onChange = (0, _react.useCallback)(function (nextValue) {
      var isSet = R.any(R.equals(nextValue), valuesList);
      var _createQuery$toJS$QUE = _slicedToArray((0, _fn.createQuery)().toJS()[_fn.QUERY_PARAMS.TRANSPORTS], 1),
        transportsMap = _createQuery$toJS$QUE[0];
      if (!isSet) {
        if (isMaxSizeOfValues) {
          return;
        }
        dispatch((0, _actions2.getOperators)(countryID, nextValue.departureID, function () {
          var nextValues = R.mergeAll([values, _defineProperty(_defineProperty(_defineProperty({}, _fn.QUERY_PARAMS.DEPARTURES, R.map(R.prop('departureID'), R.append(nextValue, valuesList))), _fn.QUERY_PARAMS.TRANSPORTS, R.map(function (_ref6) {
            var transport = _ref6.transport;
            return R.assoc(transport, true, resetTransportObj(transportsMap));
          }, R.append(nextValue, valuesList))), _fn.QUERY_PARAMS.OPERATORS, (0, _fn.createQuery)().toJS()[_fn.QUERY_PARAMS.OPERATORS])]);
          setValues(nextValues);
        }));
        dispatch(_actions.searchActions.getAvailableDates(countryID, nextValue.departureID));
      } else {
        var nextValues = R.mergeAll([values, _defineProperty(_defineProperty(_defineProperty({}, _fn.QUERY_PARAMS.DEPARTURES, R.map(R.prop('departureID'), R.without([nextValue], valuesList))), _fn.QUERY_PARAMS.TRANSPORTS, R.map(function (_ref8) {
          var transport = _ref8.transport;
          return R.assoc(transport, true, resetTransportObj(transportsMap));
        }, R.without([nextValue], valuesList))), _fn.QUERY_PARAMS.OPERATORS, (0, _fn.createQuery)().toJS()[_fn.QUERY_PARAMS.OPERATORS])]);
        setValues(nextValues);
      }
    }, [countryID, dispatch, isMaxSizeOfValues, setValues, values, valuesList]);
    var onRemove = onChange;
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
      cities: departures,
      hasError: R.isEmpty(valuesList) && R.has(_fn.QUERY_PARAMS.DEPARTURES, touched),
      isMaxSizeOfValues: isMaxSizeOfValues,
      value: valuesList,
      onChange: onChange,
      onRemove: onRemove
    }));
  };
  return (0, _formik.connect)(WithDepartureControlProps);
};
var _default = exports.default = withDepartureControlProps;